import { useState } from 'react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import { ColorModeContext } from './contexts/ColorModeContext';
import './App.css'

// ----------------------------------------------------------------------

export default function App() {
  const [mode, setMode] = useState('light');

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <ColorModeContext.Provider value={{ mode, toggleColorMode }}>
      <ThemeProvider mode={mode}>
        <ScrollToTop />
        <Router />
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
